'use strict';

bbw.directive.bbwMinAge = function() {

    return {
        require: 'ngModel',
        link: function(scope, element, attrs, ngModel) {
            ngModel.$validators.bbwMinAge = function(modelValue, viewValue) {
                var minAge = parseInt(attrs.bbwMinAge);
                if (isNaN(minAge)) {
                    minAge = bbw.configuration.age.min;
                }
                var value = modelValue || viewValue;
                if (!angular.isString(value)) {
                    return true;
                }
                var m = moment(value, "YYYY-MM-DD");
                return m.isValid() && moment().subtract(minAge, 'year').diff(m) >= 0;
            };
        }
    }
};
